import {Component, OnInit} from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-no-permission',
  templateUrl: './no-permission.component.html',
  styleUrls: ['./no-permission.component.scss']
})
export class NoPermissionComponent implements OnInit {

  constructor(private location: Location) {
  }

  ngOnInit() {
  }

  onBack() {
    this.location.historyGo(-2);
  }
}
